import { ChangeEvent, DragEvent, useRef, useState } from 'react';
import { FileSpreadsheet, UploadCloud } from 'lucide-react';

interface FileUploaderProps {
  onFile: (file: File) => void;
  isLoading: boolean;
}

export function FileUploader({ onFile, isLoading }: FileUploaderProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) onFile(file);
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files?.[0];
    if (file) onFile(file);
  };

  return (
    <section
      className={`upload-panel ${isDragging ? 'is-dragging' : ''}`}
      onDragOver={(event) => {
        event.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
      aria-label="Upload spreadsheet"
    >
      <div className="upload-icon">
        <UploadCloud aria-hidden="true" />
      </div>
      <div>
        <p className="eyebrow">Private browser-only analysis</p>
        <h1>Upload Excel data for instant operational analysis.</h1>
        <p className="hero-copy">
          data Insight profiles your workbook, adds header-based filters, highlights data quality, and keeps the file inside your browser session.
        </p>
      </div>
      <div className="upload-actions">
        <button className="primary-button" type="button" onClick={() => inputRef.current?.click()} disabled={isLoading}>
          <FileSpreadsheet size={18} aria-hidden="true" />
          {isLoading ? 'Analysing...' : 'Choose workbook'}
        </button>
      </div>
      <input
        ref={inputRef}
        className="sr-only"
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleInput}
      />
    </section>
  );
}
